import { z } from "zod"

export const InternalNoteSchema = z.object({
  id: z.string(),
  content: z.string(),
  createdAt: z.date(),
  jobId: z.string(),
})

export const CreateInternalNoteSchema = InternalNoteSchema.omit({
  id: true,
  createdAt: true,
})
export const UpdateInternalNoteSchema = CreateInternalNoteSchema.omit({
  jobId: true,
})

export type InternalNote = z.infer<typeof InternalNoteSchema>
export type CreateInternalNote = z.infer<typeof CreateInternalNoteSchema>
export type UpdateInternalNote = z.infer<typeof UpdateInternalNoteSchema>
